"use strict";

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pushNotificationWatcher = pushNotificationWatcher;
exports.registerForNotifications = registerForNotifications;
exports.unregisterForNotifications = unregisterForNotifications;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _effects = require("redux-saga/effects");
var _services = require("../../../services");
var _helpers = require("@qwkin/helpers");
var _variables = require("../../Notification/variables");
var _utils = require("../../../utils");
var _variables2 = require("../variables");
var _marked = /*#__PURE__*/_regeneratorRuntime2.mark(pushNotificationWatcher);
function registerForNotifications(_ref) {
  var payload = _ref.payload,
    meta = _ref.meta;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var _response$data, _response$data2, response;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_services.PushNotificationService.register, payload);
        case 3:
          _context.next = 5;
          return (0, _effects.put)({
            type: _variables2.REGISTER_PUSH_SUCCESS,
            payload: {
              data: payload === null || payload === void 0 ? void 0 : payload.fcmToken
            }
          });
        case 5:
          meta === null || meta === void 0 || meta.callback();
          _context.next = 16;
          break;
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](0);
          response = _context.t0.response;
          _context.next = 13;
          return (0, _effects.put)({
            type: _variables2.REGISTER_PUSH_FAILURE,
            payload: response
          });
        case 13:
          _context.next = 15;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response$data = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data !== void 0 ? _response$data : {}),
              data: response
            }
          });
        case 15:
          (0, _utils.logErr)((_response$data2 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data2 !== void 0 ? _response$data2 : {});
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 8]]);
  })();
}
function unregisterForNotifications(_ref3) {
  var payload = _ref3.payload,
    meta = _ref3.meta;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var _response$data3, _response$data4, response;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(_services.PushNotificationService.unregister, payload);
        case 3:
          _context2.next = 5;
          return (0, _effects.put)({
            type: _variables2.UNREGISTER_PUSH_SUCCESS,
            payload: {}
          });
        case 5:
          meta === null || meta === void 0 || meta.callback();
          _context2.next = 16;
          break;
        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](0);
          response = _context2.t0.response;
          _context2.next = 13;
          return (0, _effects.put)({
            type: _variables2.UNREGISTER_PUSH_FAILURE,
            payload: response
          });
        case 13:
          _context2.next = 15;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response$data3 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data3 !== void 0 ? _response$data3 : {}),
              data: response
            }
          });
        case 15:
          (0, _utils.logErr)((_response$data4 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data4 !== void 0 ? _response$data4 : {});
        case 16:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 8]]);
  })();
}
function pushNotificationWatcher() {
  return _regenerator["default"].wrap(function pushNotificationWatcher$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        _context3.next = 2;
        return (0, _effects.all)([(0, _effects.takeLatest)(_variables2.REGISTER_PUSH_REQUEST, registerForNotifications), (0, _effects.takeLatest)(_variables2.UNREGISTER_PUSH_REQUEST, unregisterForNotifications)]);
      case 2:
      case "end":
        return _context3.stop();
    }
  }, _marked);
}